// Catálogo agnóstico del juego: opciones estables, compatibles y ampliables.
export const AVATAR_CATALOG = Object.freeze({
  bases: [
    { id: 'explorador', label: 'EXPLORADOR', gameplayAsset: '/assets/player_explorador_hd.svg', portraitAsset: '/assets/mateo-astronauta-portada.png', unlockType: 'default' },
    { id: 'exploradora', label: 'EXPLORADORA', gameplayAsset: '/assets/player_exploradora_hd.svg', portraitAsset: '/assets/aurymar-astronauta-portada.png', unlockType: 'default' },
  ],
  skinTones: [
    { id: 'light', label: 'Tono claro', hex: '#f6cfb0', unlockType: 'default' },
    { id: 'medium-light', label: 'Tono medio claro', hex: '#dca47d', unlockType: 'default' },
    { id: 'medium', label: 'Tono medio', hex: '#a86d4d', unlockType: 'default' },
    { id: 'dark', label: 'Tono profundo', hex: '#70402e', unlockType: 'default' },
  ],
  hairStyles: [
    { id: 'short-01', label: 'Corto', previewClass: 'short', compatibleBases: ['explorador', 'exploradora'], unlockType: 'default' },
    { id: 'curly-01', label: 'Rizos', previewClass: 'curly', compatibleBases: ['explorador', 'exploradora'], unlockType: 'default' },
    { id: 'medium-01', label: 'Medio lacio', previewClass: 'medium', compatibleBases: ['explorador', 'exploradora'], unlockType: 'default' },
    { id: 'waves-01', label: 'Ondulado', previewClass: 'waves', compatibleBases: ['explorador', 'exploradora'], unlockType: 'default' },
  ],
  hairColors: [
    { id: 'black', label: 'Negro', hex: '#211b2c', unlockType: 'default' },
    { id: 'dark-brown', label: 'Castaño oscuro', hex: '#543323', unlockType: 'default' },
    { id: 'light-brown', label: 'Castaño claro', hex: '#a8673e', unlockType: 'default' },
    { id: 'blonde', label: 'Rubio', hex: '#d8ad56', unlockType: 'default' },
  ],
  suitAccents: [
    { id: 'cyan', label: 'CIAN', hex: '#36f5ee', unlockType: 'default' },
    { id: 'violet', label: 'VIOLETA', hex: '#a78bfa', unlockType: 'default' },
    { id: 'magenta', label: 'MAGENTA', hex: '#ff4ed8', unlockType: 'default' },
    { id: 'gold', label: 'DORADO', hex: '#ffd23f', unlockType: 'default' },
    { id: 'green', label: 'VERDE', hex: '#4dff9e', unlockType: 'default' },
  ],
});

export const avatarOptions = category => AVATAR_CATALOG[category] || [];

export const getAvatarOption = (category, id) =>
  avatarOptions(category).find(option => option.id === id) || null;

export const getCompatibleHairStyles = base =>
  avatarOptions('hairStyles').filter(style => style.compatibleBases.includes(base));

export const isValidAvatarOption = (category, id) => !!getAvatarOption(category, id);
